import React, { FC } from 'react';
import { Maybe } from '@/common/types';
import { FactorCategory } from '../types/FactorCategory.enum';
import { OutcomeCategory } from '../types/OutcomeCategory.enum';
import { OutcomeFactor } from '../types/types';
import { OutcomeSlider } from './OutcomeSlider';

interface OutcomeSliderContainerProps {
    factors: Maybe<OutcomeFactor[]>;
    factorResultCategory?: Maybe<FactorCategory>;
    type: Maybe<OutcomeCategory>;
}

export const OutcomeSliderContainer: FC<OutcomeSliderContainerProps> = ({ factors, factorResultCategory, type }) => {
    const outcomeSliderData = { factors, factorResultCategory };

    return <OutcomeSlider outcomeSliderData={outcomeSliderData} showCriteria={true} type={type} />;
};
